!function webpackUniversalModuleDefinition(e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@wordpress/priority-queue"] = t() : (e.wp = e.wp || {}, e.wp.priorityQueue = t());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      464: function _(e, t) {
        "use strict";

        function createRequestIdleCallback() {
          return "undefined" == typeof window ? function (e) {
            setTimeout(function () {
              return e(Date.now());
            }, 0);
          } : window.requestIdleCallback || window.requestAnimationFrame;
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createRequestIdleCallback = createRequestIdleCallback, t.default = void 0;
        var r = createRequestIdleCallback();
        t.default = r;
      }
    },
        t = {};

    function __webpack_require__(r) {
      var u = t[r];
      if (void 0 !== u) return u.exports;
      var o = t[r] = {
        exports: {}
      };
      return e[r](o, o.exports, __webpack_require__), o.exports;
    }

    var r = {};
    return function () {
      "use strict";

      var e = r,
          t = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.createQueue = void 0;
      var u = t(__webpack_require__(464));

      e.createQueue = function () {
        var e = [],
            t = new WeakMap(),
            r = !1;

        var runWaitingList = function runWaitingList(o) {
          var n = "number" == typeof o ? function () {
            return !1;
          } : function () {
            return o.timeRemaining() > 0;
          };

          do {
            if (0 === e.length) return void (r = !1);

            var _u = e.shift();

            t.get(_u)(), t.delete(_u);
          } while (n());

          (0, u.default)(runWaitingList);
        };

        return {
          add: function add(o, n) {
            t.has(o) || e.push(o), t.set(o, n), r || (r = !0, (0, u.default)(runWaitingList));
          },
          flush: function flush(r) {
            if (!t.has(r)) return !1;
            var u = e.indexOf(r);
            e.splice(u, 1);
            var o = t.get(r);
            return t.delete(r), o(), !0;
          },
          reset: function reset() {
            e = [], t = new WeakMap(), r = !1;
          }
        };
      };
    }(), r;
  }();
});